import { getCategoryHref } from '../../utils/common/category';
import { BOOK_TITLE_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'bookTitleGeneratorType',
      analyticsName: 'book_title_type',
      textLabel: 'Generate titles for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: BOOK_TITLE_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'Book',
        value: getCategoryHref(BOOK_TITLE_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'bookTitleGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'book_titles_generator',
      placeholder: 'Try "humor about a modern family" or "science fiction and AI"',
      textLabel: 'Describe your book’s topic',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: BOOK_TITLE_GENERATOR_CATEGORY,
      required: true,
      tooltipProps: null,
    },
  },
];

export default data;
